/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useEffect, useState, useRef, useMemo } from 'react';
import MultiSelectorItem from './FilterableMultiSelectorItem/FilterableMultiSeletorItem';
import MultiSelectedItem from './MultiSelectedItem/MultiSelectedItem';
import DropDown from '../../Compound/DropDown/DropDown';
import Button from '../Button/Button';
import Icon from '../../DataDisplay/Icon/Icon';
import ErrorText from '../../Text/ErrorText/ErrorText';
import styles from './FilterableMultiSelector.module.scss';
import { SelectOption } from '../Select/Select1';

export type FilterableMultiSelectorProps<Data extends object = Record<string, never>> = {
  id?: string;
  variant?: 'multi' | 'underline' | 'outline';
  name: string;
  value?: SelectOption<Data>[];
  isActive?: boolean;
  items?: SelectOption<Data>[];
  labelSize?: string;
  height?: string;
  minHeight?: string;
  minWidth?: string;
  indicatorMinHeight?: string;
  borderColor?: string;
  hasSelectAll?: boolean;
  selectAllLabel?: string;
  isDisabled?: boolean;
  disabledLabel?: string;
  itemHeight?: string;
  borderRadius?: string;
  borderWidth?: string;
  color?: string;
  style?: object;
  // TODO: is this used?
  // allowNew?: boolean;
  newTitle?: string;
  nosort?: boolean;
  placeholder?: string;
  isNew: boolean;
  displayCheck?: boolean;
  error?: string | string[] | null;
  lockedItemContact?: () => void;
  disabled?: boolean;
  setFieldValue?: (field: string, value: string) => void;
  onClose?: (values: string) => void;
  position?: 'absolute' | 'fixed';
  // useStateValues?: boolean; // TODO: not used anywhere?
  searchCallback?: (value: string) => void;
  onSelect?: (items: SelectOption<Data>[]) => void;
  renderOption?: (o: SelectOption<Data>, args: { selected: boolean; focused: boolean }) => React.ReactNode;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

function FilterableMultiSelector<Data extends object = Record<string, never>>({
  variant = 'multi',
  name,
  value,
  isActive,
  disabled,
  items,
  labelSize,
  height,
  minHeight,
  minWidth,
  indicatorMinHeight,
  borderColor,
  hasSelectAll,
  selectAllLabel = 'Select All',
  isDisabled = false,
  disabledLabel,
  itemHeight,
  borderRadius,
  borderWidth,
  color,
  style,
  newTitle,
  nosort = false,
  placeholder = 'Search',
  displayCheck = true,
  setFieldValue,
  onSelect,
  onClose = () => {},
  error = null,
  lockedItemContact = () => {},
  searchCallback = () => {},
  isNew,
  renderOption,
  position,
  onBlur,
}: FilterableMultiSelectorProps<Data>) {
  type GenericItem = SelectOption<Data>;

  const boxRef = useRef<HTMLDivElement>(null);
  const wordListRef = useRef<HTMLSpanElement>(null);
  const [multiItems, setMultiItems] = useState<GenericItem[]>([]);
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [itemsUpdated, setItemsUpdated] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState<string | React.JSX.Element>('');
  const [selectedItems, setSelectedItems] = useState<GenericItem[]>([]);
  const [topPosition, setTopPosition] = useState('');
  const [filter, setFilter] = useState('');
  const [activeItem, setSetActiveItem] = useState(0);

  const [hasInitialized, setHasInitialized] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [page, setPage] = useState(1);
  const [hasLoadMore, setHasLoadMore] = useState(false);

  const allSelected = useMemo(
    () => multiItems.length === selectedItems.length,
    [hasSelectAll, multiItems, selectedItems],
  );

  const PAGE_SIZE = 20;
  useEffect(() => {
    const hasMore = multiItems?.length > page * PAGE_SIZE;
    setHasLoadMore(hasMore);
  }, [PAGE_SIZE, page, multiItems]);
  useEffect(() => {
    if (items && (hasInitialized || items?.length > 0)) {
      setHasInitialized(true);
      setMultiItems(items);
      setItemsUpdated(true);
    }
  }, [items]);
  useEffect(() => {
    // Clear the previous timer (if any) when the searchTerm changes
    const timerId = setTimeout(() => {
      if (filter.length > 1 || filter.length === 0) {
        setSetActiveItem(0);
        searchCallback(filter);
      }
    }, 1000);
    return () => clearTimeout(timerId);
  }, [filter]);

  useEffect(() => {
    if (itemsUpdated) {
      setItemsUpdated(false);

      const selectItems = multiItems;
      const sortedItems = nosort
        ? (selectItems ?? [])
        : (selectItems ?? []).slice().sort((a, b) => a.label.localeCompare(b.label));

      setMultiItems(sortedItems);
    }
  }, [itemsUpdated, multiItems, hasSelectAll, selectAllLabel]);
  const handleDelete = (value: string) => {
    const updatedSelectedItems = selectedItems.filter((item) => item.value !== value);
    setSelectedItems(updatedSelectedItems);
    handleSelectCallbacks(updatedSelectedItems);
    if (inputRef.current && isMenuVisible) {
      inputRef.current.focus({ preventScroll: true });
    }
  };
  const [lastValues, setLastValues] = useState<SelectOption<Data>[]>([]);
  // update selected label
  useEffect(() => {
    if (value) {
      const allEqual =
        value.every((obj, index) => JSON.stringify(obj) === JSON.stringify(lastValues[index])) &&
        value.length === lastValues.length;

      if (!allEqual) {
        setSelectedItems(value || []);
        setLastValues(value);
      }
    }
  }, [value]);

  useEffect(() => {
    if (isNew) {
      setSelectedLabel(newTitle || 'New');
    } else {
      setSelectedLabel(
        (
          <>
            {selectedItems
              ?.filter((selectedItem) => selectedItem !== undefined)
              .map((selectedItem) => (
                <MultiSelectedItem
                  key={selectedItem.value}
                  label={selectedItem.label}
                  value={selectedItem.value}
                  onDelete={handleDelete}
                />
              ))}{' '}
          </>
        ) || '',
      );
    }
  }, [selectedItems]);

  // dropdown position
  useEffect(() => {
    const updatePosition = () => {
      if (boxRef.current) {
        const boxHeight = boxRef.current.clientHeight;
        setTopPosition(`${boxHeight + 2}px`);
      }
    };

    updatePosition();
    window.addEventListener('resize', updatePosition);

    return () => {
      window.removeEventListener('resize', updatePosition);
    };
  }, [boxRef?.current?.clientHeight]);

  useEffect(() => {
    if (!isMenuVisible) {
      // to fix this issue
      onClose(selectedItems.map((item) => item.label).join(';'));

      if (wordListRef.current) {
        wordListRef.current.scrollLeft = 0;
      }

      setFilter('');
      setPage(1);
      setSetActiveItem(0);
    } else if (isMenuVisible && inputRef.current) {
      inputRef.current.focus();

      if (wordListRef.current) {
        wordListRef.current.scrollLeft = wordListRef.current.scrollWidth - wordListRef.current.clientWidth;
      }
    }
  }, [isMenuVisible]);

  // TODO: change
  const handleItemCheck = (idx: number, isChecked: boolean, isFocus = true) => {
    let selectedValues = [...selectedItems];

    if (hasSelectAll && idx === 0) {
      if (isChecked) {
        selectedValues = [...multiItems];
        setSelectedItems(selectedValues);
      } else {
        const selectedValues = selectedItems.filter((item) => item.value !== multiItems[idx].value);
        setSelectedItems(selectedValues);
      }
    } else if (isChecked === true) {
      selectedValues = [...selectedItems, multiItems[idx]];
      setSelectedItems(selectedValues);
    } else {
      selectedValues = selectedItems.filter((item) => item.value !== multiItems[idx].value);
      setSelectedItems(selectedValues);
    }

    if (inputRef.current && isMenuVisible && isFocus) {
      inputRef.current.focus();
    }

    handleSelectCallbacks(selectedValues);
  };

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedItems(multiItems);
    } else {
      setSelectedItems([]);
    }
  };

  const handleLoadMore = (isFocus = true) => {
    setPage(page + 1);

    if (isFocus && isMenuVisible && inputRef.current) {
      inputRef.current.focus();
    }
  };

  const [labelWidth, setLabelWidth] = useState(0);
  useEffect(() => {
    if (boxRef.current) {
      setLabelWidth(boxRef.current?.clientWidth - 57); // Adjusting for padding/border/margins
    }

    const updateWidth = () => {
      if (boxRef.current) {
        const newWidth = boxRef.current?.clientWidth - 57; // Adjusting for padding/border/margins
        setLabelWidth(newWidth);
      }
    };

    updateWidth();

    const handleResize = () => {
      updateWidth();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [boxRef.current?.clientWidth]); // Re-calculate when multiItems change

  useEffect(() => {
    if (wordListRef.current) {
      if (isMenuVisible) {
        wordListRef.current.scrollLeft = wordListRef.current.scrollWidth - wordListRef.current.clientWidth;
      }
    }
  }, [selectedLabel, wordListRef.current, wordListRef.current?.scrollWidth, wordListRef.current?.clientWidth]);

  const offset = isNew ? 2 : 1;
  const loadMoreRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (hasLoadMore && activeItem === Math.min(multiItems.length, page * PAGE_SIZE) + offset && loadMoreRef.current) {
      loadMoreRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [activeItem]);

  function handleSelectCallbacks(items: GenericItem[]) {
    const validItems = items.filter((item) => item !== undefined);

    if (setFieldValue) {
      setFieldValue(name, validItems.map((item) => item.value).join('|'));
    }

    if (onSelect) {
      onSelect(validItems);
    }
  }

  const handlerBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    onBlur && onBlur(event);
  };

  return (
    <>
      <div
        ref={boxRef}
        className={[
          styles.multiSelectBox,
          styles[variant],
          styles[getActiveClass()],
          styles[getDisabledClass()],
          styles[getErrorClass()],
        ].join(' ')}
        onBlur={handlerBlur}
        style={{ ...style, height, minHeight, minWidth, borderColor, borderRadius, borderWidth, color }}
        onKeyDown={handleKeyDown}
      >
        <DropDown
          label={
            <span className={styles.labelContainer} style={{ width: labelWidth }}>
              <span className={styles.labelList} ref={wordListRef}>
                {isDisabled ? (
                  disabledLabel
                ) : selectedItems.length === 0 && placeholder && !isMenuVisible ? (
                  <span className={styles.placeholder}>{placeholder}</span>
                ) : (
                  selectedLabel
                )}

                {isMenuVisible && (
                  <input
                    type="text"
                    placeholder={placeholder}
                    className={styles.embeddedInput}
                    value={filter}
                    disabled={isDisabled}
                    onChange={(e) => {
                      setFilter(e.target.value);
                    }}
                    ref={inputRef}
                  />
                )}
              </span>
            </span>
          }
          fontColor={selectedItems.length === 0 && placeholder ? '#949494' : undefined}
          variant="multiFilter"
          maxHeight="200px"
          disabled={disabled}
          isMenuVisible={isMenuVisible}
          topPosition={topPosition}
          indicatorMinHeight={indicatorMinHeight}
          onClick={!isDisabled ? setIsMenuVisible : () => {}}
          position={position}
          dropdownStyle={{
            '--menuBorder': 'none',
            '--menuBg': 'var(--vopayWhite)',
            '--menuTop': '49px',
            // '--menuPadding': '0px 12px',
            ...(renderOption
              ? {
                  '--sectionSeparator': 'none',
                  '--menuPadding': '0',
                }
              : {}),
          }}
        >
          {/* TODO: is this used? */}
          {/* {allowNew && (
            <div
              className={[styles.itemContainer, styles[addNewStyle]].join(' ')}
              onClick={() => {
                onClickNew();
              }}
            >
              {addNewStyle === 'bolded' && <Icon icon="add" height="20px" width="20px" />} {'  '} {newTitle || 'New'}
            </div>
          )} */}

          <div className={styles.message}>Select one or more options</div>

          {hasSelectAll && (
            <MultiSelectorItem
              idx={-1}
              label={selectAllLabel}
              isChecked={displayCheck && allSelected}
              isDisabled={isDisabled}
              labelSize={labelSize}
              itemHeight={itemHeight}
              onClick={handleSelectAll}
            />
          )}

          {multiItems.slice(0, page * PAGE_SIZE).map((item, idx) => {
            const { label, isReadOnly, isDisabled, isLocked } = item;
            const selected = displayCheck && selectedItems.some((item) => item?.value === multiItems[idx]?.value);
            const focused = activeItem === idx + offset;

            return (
              <MultiSelectorItem
                key={`MultiSelector-${idx}`}
                idx={idx}
                isCurrentItem={focused}
                label={label}
                template={renderOption && renderOption(item, { selected, focused })}
                isChecked={selected}
                isDisabled={isDisabled}
                isReadOnly={isReadOnly}
                isLocked={isLocked}
                labelSize={labelSize}
                itemHeight={itemHeight}
                lockedItemContact={lockedItemContact}
                onClick={handleItemCheck}
              />
            );
          })}
          {hasLoadMore && (
            <div
              className={[
                styles.itemContainer,
                activeItem === Math.min(multiItems.length, page * PAGE_SIZE) + offset ? styles.currentItem : '',
              ].join(' ')}
              ref={loadMoreRef}
              onClick={() => {
                handleLoadMore();
              }}
            >
              <Icon icon="add" height="20px" width="20px" /> Load More
            </div>
          )}
          {multiItems.length === 0 && filter !== '' && (
            <div className={[styles.itemContainer, styles.regular].join(' ')} onClick={() => {}}>
              {filter} No results found
            </div>
          )}
        </DropDown>

        <div className={styles.iconContainer}>
          <Button
            id="open-multi-select"
            label=""
            background="transparent"
            noShadow
            noPadding
            size="sm"
            icon="angleDown"
            iconSize="xsm"
            color="secondary"
            iconLocation="center"
            isCircle
            onClick={() => {
              !isDisabled && setIsMenuVisible(!isMenuVisible);
            }}
          />
        </div>
      </div>

      {error && <ErrorText error={error} size="sm" indentation />}
    </>
  );

  function handleKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    if (!isMenuVisible && !isDisabled) setIsMenuVisible(!isMenuVisible);

    const handlers: { [key: string]: () => void } = {
      ArrowLeft: () => {
        if (wordListRef.current) {
          const children = Array.from(wordListRef.current.children);
          const offScreenItem = children
            .reverse()
            .find(
              (child) =>
                child.getBoundingClientRect().left <
                (wordListRef.current as HTMLSpanElement).getBoundingClientRect().left,
            );
          if (offScreenItem) {
            wordListRef.current.scrollLeft -=
              wordListRef.current.getBoundingClientRect().left - offScreenItem.getBoundingClientRect().left;
          }
        }
        if (inputRef.current) {
          inputRef.current.focus();
        }
        event.preventDefault();
      },
      ArrowRight: () => {
        if (wordListRef.current) {
          const children = Array.from(wordListRef.current.children);
          const offScreenItem = children.find(
            (child) =>
              child.getBoundingClientRect().right >
              (wordListRef.current as HTMLSpanElement).getBoundingClientRect().right,
          );
          if (offScreenItem) {
            wordListRef.current.scrollLeft +=
              offScreenItem.getBoundingClientRect().right -
              wordListRef.current.getBoundingClientRect().right +
              offScreenItem.getBoundingClientRect().width / 2;
          }
        }
        if (inputRef.current) {
          inputRef.current.focus();
        }
        event.preventDefault();
      },
      ArrowUp: () => {
        setSetActiveItem(Math.max(activeItem - 1, 1));
        event.preventDefault();
      },
      ArrowDown: () => {
        setSetActiveItem(Math.min(activeItem + 1, hasLoadMore ? page * PAGE_SIZE + offset : page * PAGE_SIZE));
        event.preventDefault();
      },
      Enter: () => {
        if (isMenuVisible) {
          if (activeItem - offset >= Math.min(multiItems.length, page * PAGE_SIZE)) {
            handleLoadMore(false);
          } else {
            const currentItem = multiItems[activeItem - offset];
            if (currentItem) {
              handleItemCheck(
                activeItem - offset,
                !selectedItems.some((item) => item?.value === currentItem.value),
                false,
              );
            }
          }
        }
      },
      default: () => {},
    };

    const handler = event.key.length === 1 ? handlers.Space : handlers[event.key] || handlers.default;
    if (typeof handler === 'function') {
      handler();
    }
  }
  function getActiveClass() {
    return isActive ? 'active' : '';
  }

  function getDisabledClass() {
    return isDisabled ? 'disabled' : '';
  }
  function getErrorClass() {
    return error ? 'error' : '';
  }
}

export default FilterableMultiSelector;
